module.exports = __webpack_public_path__ + "static/img/fluorometer.0437d04.svg";